import { Appearance } from "@stripe/stripe-js";

import { getColors, FONT_FAMILIES, RADII } from "../../common/consts";
import { ThemeMode } from "../../common/contexts/ThemeContext";

/**
 * Builds a Stripe Elements appearance from the app's design tokens so the
 * Payment Element matches the dashboard in both light and dark mode.
 */
export const buildStripeAppearance = (mode: ThemeMode): Appearance => {
  const colors = getColors(mode);

  return {
    theme: mode === "dark" ? "night" : "stripe",
    variables: {
      colorPrimary: colors.foregroundBrand,
      colorBackground: colors.backgroundWhite,
      colorText: colors.foregroundPrimary,
      colorTextSecondary: colors.foregroundSecondary,
      colorTextPlaceholder: colors.foregroundSecondaryLight,
      colorDanger: "#df1b41",
      fontFamily: FONT_FAMILIES.regular,
      borderRadius: RADII.md,
    },
    rules: {
      ".Input": {
        border: `1px solid ${colors.borderPrimary}`,
        boxShadow: "none",
      },
      ".Input:focus": {
        border: `1px solid ${colors.foregroundBrand}`,
        boxShadow: "none",
      },
      ".Label": {
        color: colors.foregroundSecondary,
      },
      ".Tab": {
        border: `1px solid ${colors.borderPrimary}`,
        backgroundColor: colors.backgroundWhite,
      },
      ".Tab--selected": {
        border: `1px solid ${colors.foregroundBrand}`,
      },
    },
  };
};
